export type IconName =
  | 'arrow'
  | 'search'
  | 'grid'
  | 'code'
  | 'check'
  | 'layers'
  | 'close'
  | 'menu'
  | 'download'
  | 'external'
  | 'chevron'
  | 'copy'
  | 'spark'
  | 'clock'
  | 'file'
  | 'info'
  | 'sun'
  | 'moon'
  | 'sliders'
  | 'play'
  | 'pause'
  | 'pen'
  | 'plus'
  | 'reset'
  | 'star'
  | 'lock'
  | 'landmark'
  | 'globe'
  | 'calendar'
  | 'upload'
  | 'sort'
  | 'filter'
  | 'sidebar'
  | 'share'
const paths: Record<IconName, string> = {
  arrow: 'M4 12h15m-6-6 6 6-6 6',
  search: 'M21 21l-5-5M10.5 18a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15',
  grid: 'M3 3h7v7H3zM14 3h7v7h-7zM3 14h7v7H3zM14 14h7v7h-7z',
  code: 'm8 6-6 6 6 6m8-12 6 6-6 6m-3-15-2 18',
  check: 'm5 12 4 4L19 6',
  layers: 'm12 2 10 5-10 5L2 7l10-5Zm-10 10 10 5 10-5M2 17l10 5 10-5',
  close: 'm6 6 12 12M6 18 18 6',
  menu: 'M3 6h18M3 12h18M3 18h18',
  download: 'M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5',
  external: 'M14 3h7v7m0-7L10 14M10 3H3v18h18v-7',
  chevron: 'm9 5 7 7-7 7',
  copy: 'M9 9h12v12H9zM15 6V3H3v12h3',
  spark: 'm12 2 2.8 7.2L22 12l-7.2 2.8L12 22l-2.8-7.2L2 12l7.2-2.8L12 2Z',
  clock: 'M12 8v5l3 2M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0',
  file: 'M14 2H4v20h16V8l-6-6Zm0 0v6h6M8 12h8M8 16h6',
  info: 'M12 16v-5m0-3.5v-.01M22 12a10 10 0 1 0-20 0 10 10 0 0 0 20 0',
  sun: 'M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10ZM12 1v2m0 18v2M4.2 4.2l1.4 1.4m12.8 12.8 1.4 1.4M1 12h2m18 0h2M4.2 19.8l1.4-1.4M18.4 5.6l1.4-1.4',
  moon: 'M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8Z',
  sliders: 'M4 6h10m4 0h2M4 12h4m4 0h8M4 18h12m4 0h0M16 4v4M10 10v4M18 16v4',
  play: 'M7 4.5v15l12-7.5-12-7.5Z',
  pause: 'M8 5v14m8-14v14',
  pen: 'M15.2 5.2 18.8 8.8M4 20l1-4.6L16.4 4a1.9 1.9 0 0 1 2.7 0l.9.9a1.9 1.9 0 0 1 0 2.7L8.6 19 4 20Z',
  plus: 'M12 5v14M5 12h14',
  reset: 'M3 12a9 9 0 1 0 2.6-6.4M3 4v5h5',
  lock: 'M6 11h12v10H6zM8.5 11V7.5a3.5 3.5 0 0 1 7 0V11',
  landmark: 'M3 21h18M5 18h14M6 18v-7m4 7v-7m4 7v-7m4 7v-7M3 9l9-5 9 5H3Z',
  globe: 'M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM2 12h20M12 2c2.6 2.7 4 6.2 4 10s-1.4 7.3-4 10c-2.6-2.7-4-6.2-4-10s1.4-7.3 4-10Z',
  calendar: 'M4 6h16v15H4zM4 10h16M8 3v4m8-4v4',
  upload: 'M12 16V4m0 0-5 5m5-5 5 5M4 16v4h16v-4',
  sort: 'm8 9 4-4 4 4m-8 6 4 4 4-4',
  filter: 'M4 5h16l-6 7.5V19l-4 2v-8.5L4 5Z',
  sidebar: 'M3 5h18v14H3zM9 5v14',
  share: 'M12 3v12m-4-8 4-4 4 4M5 12v8h14v-8',
  star: 'm12 3 2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1-4.4-4.3 6.1-.9L12 3Z',
}
export default function Icon({
  name,
  size = 20,
  className = '',
}: {
  name: IconName
  size?: number
  className?: string
}) {
  return (
    <svg
      width={size}
      height={size}
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={paths[name]} />
    </svg>
  )
}
